<script setup>
import { computed } from 'vue'
import { useLocaleStore } from '@/stores/localeStore'
import leftMenuData from '@/data/left-menu-data.json'

// Props sans withDefaults (compatible partout)
const props = defineProps({
  leftMenuType: {
    type: String,
    default: 'default'
  }
})

// Store locale
const localeStore = useLocaleStore()
const currentLocale = computed(() => localeStore.currentLocale)

// Left menu sécurisé
const leftMenu = computed(() => {
  const type = props.leftMenuType || 'default'
  const data = leftMenuData?.leftMenuItems?.[type]

  // fallback si invalide
  if (!Array.isArray(data)) {
    console.warn(`[WindowLeftMenu] leftMenuType "${type}" introuvable → fallback "default"`)
    return leftMenuData?.leftMenuItems?.default || []
  }

  return data
})

console.log('[WindowLeftMenu] type reçu =', props.leftMenuType)
console.log('[WindowLeftMenu] menu chargé =', leftMenu.value)

const getLocalizedTitle = (item) => {
  if (!item?.title) return ''
  return item.title[currentLocale.value] || item.title.fr || ''
}

const getLocalizedSubtitle = (subtask) => {
  if (!subtask?.subtitle) return ''
  return subtask.subtitle[currentLocale.value] || subtask.subtitle.fr || ''
}
</script>